
import React from 'react';
import {createRoot} from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CookiesProvider } from 'react-cookie';

import * as serviceWorker from './serviceWorker.js';
import { Provider } from 'react-redux';
import store from './store/store';
import { ThemeProvider } from 'styled-components';
import { lightTheme } from './styles/theme';


import './i18n';

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element')
const root = createRoot(container);

const tree = (
  <Provider store={store}>
    <ThemeProvider theme={lightTheme}>
      <CookiesProvider>
        <App />
      </CookiesProvider>
    </ThemeProvider>
  </Provider>
);

// StrictMode is dev-only: it surfaces React 19 deprecation warnings and
// double-mounts effects to catch impurities, without affecting production.
root.render(import.meta.env.DEV ? <React.StrictMode>{tree}</React.StrictMode> : tree)

// serviceWorker.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
